import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Vue Admin Template'
const whiteListTitle = ['到店路线']
export default function getPageTitle(pageTitle) {
  if(whiteListTitle.includes(pageTitle)){
    return `${pageTitle}`
  }
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
